export const baseRouteSignIn: string = "/account/login";
export const baseRouteNewSummary: string = "/video/ai/new";
export const baseRouteSummaryModeFree: string = "/video/summary";
export const baseRouteSummaryMode: string = "/video/ai/summary";

export const baseRouteSettingsSubscriptions: string = "/settings/subscriptions";
export const baseRoutePricing: string = "/pricing";

export const baseRouteSupport: string = "mailto:hello@videohighlight.com?subject=Support%20Request";
export const baseRouteSupportDiscord = process.env.NEXT_PUBLIC_DISCORD_INVITE;
export const baseRouteUpdates = "/updates";

export const baseRoutePrivacyPolicy: string = "/privacy-policy";
export const baseRouteTermsOfService: string = "/terms-of-service";
export const baseRouteDocs: string = "https://docs.videohighlight.com/";